import React, { useState, useEffect } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { FaSearch, FaLink } from 'react-icons/fa'
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Table,
  Input,
  InputGroupAddon,
  FormGroup,
  InputGroup
} from 'reactstrap'

import classnames from 'classnames';

import Header from '../../components/Header/Header'

import api from '../../services/api';

import './styles.css';

export default function Person() {
  const [name, setName] = useState('');
  const [peopleExist, setPeopleExist] = useState()
  const [people, setPeople] = useState([])
  const [selectedPerson, setSelectedPerson] = useState('')
  const [newName, setNewName] = useState('')
  const [activeTab, setActiveTab] = useState('1');
  const [btnDisabled, setBtnDisabled] = useState(false)
  const history = useHistory();

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  }

  let id_company = localStorage.getItem('followize_id_company');
  let id_contact = localStorage.getItem('followize_id_contact');
  let id_user = localStorage.getItem('followize_id_user');
  let token = localStorage.getItem('followize_token');

  const getPersonDigisac = async () => {
    const response = await api.get('/person/id?id_company=' + id_company + '&id_contact=' + id_contact + '&id_user=' + id_user);
    setPeopleExist(response.data)
  }

  useEffect(() => {
    getPersonDigisac()
  }, [])

  async function searchPerson(e) {
    e.preventDefault();

    if (name.length < 3) {
      alert('O nome deve conter no mínimo 3 caracteres')
      return
    }

    try {

      const response = await api.get('person/search?name=' + name + '&id_company=' + id_company + '&id_contact=' + id_contact + '&id_user=' + id_user + '&token=' + token);

      setPeople(response.data)

    } catch (err) {
      console.log(err);
    }
  }

  const formatTable = () => {
    const person = people.people ?? []

    if (!person.length) {
      return <tr>
        <td colSpan={2}>Nenhuma pessoa encontrada</td>
      </tr>
    }

    return person.map(person => {
      return <tr>
        <td>{person.name}</td>
        <td>
          <Input
            value={person.id}
            type='radio'
            name='person'
            onChange={(item) => setSelectedPerson(item.target.value)}
          />
        </td>
      </tr>
    })
  }

  async function storePerson(e) {
    e.preventDefault();

    if (!newName) {
      alert('O nome deve ser preenchido')
      return
    }

    const name = newName;

    try {
      await api.post('person/save', { name, token, id_company, id_contact, id_user });

      history.push('/?id_company=' + id_company + '&id_contact=' + id_contact + '&id_user=' + id_user);

    } catch (err) {
      console.log(err);
    }
  }

  async function attachPerson(e) {
    e.preventDefault();

    if (!selectedPerson) {
      alert('A pessoa deve ser escolhida')
      return
    }

    try {
      await api.post('person/attach', {
        'id_company_attach': id_company,
        'id_user_attach': id_user,
        'selected_person': selectedPerson,
        'id_contact_attach': id_contact,
        'digisac_params': null
      });

      localStorage.setItem('person_id', peopleExist);

      history.push('/?id_company=' + id_company + '&id_contact=' + id_contact + '&id_user=' + id_user);

      // <Redirect to={{pathname:'/contact', state:{people: peopleExist}}}/>

    } catch (err) {
      alert(err.message)
    }
  }

  return (
    <>
        <Header title="Vinculação de Pessoa na Digisac" />
        <Nav tabs>
          <NavItem>
            <NavLink
              href="#"
              onClick={() => { toggle('1'); }}
              className={classnames({ active: activeTab === '1' })}
            >
              Buscar
                </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              href="#"
              onClick={() => { toggle('2'); }}
              className={classnames({ active: activeTab === '2' })}
            >
              Adicionar
                </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab} className="block-person">
          <TabPane tabId="1" style={{ marginTop: '10px' }}>
            <FormGroup>
              <InputGroup>
                <Input
                  placeholder="Nome"
                  value={name}
                  onChange={(item) => setName(item.target.value)}
                />
                <InputGroupAddon addonType="append">
                  <Button
                    className="btn btn-primary btn-search"
                    color="info"
                    onClick={searchPerson}
                    disabled={btnDisabled}
                  >
                    <FaSearch />
                  </Button>
                </InputGroupAddon>
              </InputGroup>
            </FormGroup>
            <Table>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {formatTable()}
              </tbody>
            </Table>
            <button
              disabled={btnDisabled}
              onClick={attachPerson}
              className="button"
            >
              <FaLink />&nbsp;&nbsp;Vincular pessoa
                </button>
          </TabPane>
          <TabPane tabId="2" style={{ marginTop: '10px' }}>
            <FormGroup>
              <Input
                placeholder="Nome"
                value={newName}
                onChange={(item) => setNewName(item.target.value)}
              />
            </FormGroup>
            <button
              disabled={btnDisabled}
              onClick={storePerson}
              className="button"
            >
              <FaLink />&nbsp;&nbsp;Criar e vincular pessoa
                </button>
          </TabPane>
        </TabContent>
    </>
  )
}